<template>
  <div class="cplus-pagination" :class="{ 'cplus-pagination--compact': compact }">
    <div class="cplus-pagination__controls">
      <el-button v-if="showBoundaryButtons" class="cplus-pagination__boundary" size="mini" icon="el-icon-d-arrow-left" title="首页" :disabled="disabled || currentPage <= 1" @click="changePage(1)" />
      <el-pagination background :small="compact" :disabled="disabled" :layout="resolvedLayout" :current-page="currentPage" :page-size="pageSize" :page-sizes="pageSizes" :total="total" @size-change="changePageSize" @current-change="changePage" />
      <div v-if="compact" class="cplus-pagination__compact-jump">
        <span>第</span>
        <el-input v-model="jumpPage" size="mini" :disabled="disabled" aria-label="页码" @keyup.enter.native="submitCompactJump" />
        <span>/ 共 {{ pageCount }} 页</span>
      </div>
      <el-button v-if="showBoundaryButtons" class="cplus-pagination__boundary" size="mini" icon="el-icon-d-arrow-right" title="末页" :disabled="disabled || currentPage >= pageCount" @click="changePage(pageCount)" />
      <el-button v-if="showRefresh" class="cplus-pagination__refresh" size="mini" icon="el-icon-refresh" title="刷新" :disabled="disabled" @click="$emit('refresh')" />
    </div>
    <div v-if="summary" class="cplus-pagination__summary">{{ summary }}</div>
  </div>
</template>

<script>
export default {
  name: 'CPlusPagination',
  data() {
    return { jumpPage: String(this.currentPage) }
  },
  props: {
    currentPage: { type: Number, default: 1 },
    pageSize: { type: Number, default: 10 },
    pageSizes: { type: Array, default: () => [10, 20, 30, 40, 50] },
    total: { type: Number, default: 0 },
    layout: { type: String, default: 'total, sizes, prev, pager, next, jumper' },
    compact: { type: Boolean, default: false },
    showBoundaryButtons: { type: Boolean, default: false },
    showRefresh: { type: Boolean, default: false },
    summary: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    pageCount() {
      return Math.max(1, Math.ceil(this.total / Math.max(1, this.pageSize)))
    },
    resolvedLayout() {
      return this.compact ? 'prev, next' : this.layout
    }
  },
  watch: {
    currentPage(value) {
      this.jumpPage = String(value)
    }
  },
  methods: {
    changePageSize(value) {
      this.$emit('update:pageSize', value)
      this.$emit('size-change', value)
    },
    changePage(value) {
      const page = Math.min(this.pageCount, Math.max(1, Number(value) || 1))
      this.jumpPage = String(page)
      this.$emit('update:currentPage', page)
      this.$emit('current-change', page)
    },
    submitCompactJump() {
      this.changePage(this.jumpPage)
    }
  }
}
</script>

<style scoped>
.cplus-pagination{display:flex;width:100%;min-height:56px;padding:10px 14px;align-items:center;justify-content:flex-end;gap:14px;overflow:hidden;color:#5d6988;background:rgba(255,255,255,.94);border:1px solid #dde5f3;border-top:0;border-radius:0 0 12px 12px}
.cplus-pagination__controls{display:flex;min-width:0;align-items:center;justify-content:flex-end;gap:8px}.cplus-pagination__summary{flex:0 0 auto;color:#6b7795;font-size:13px;white-space:nowrap}
.cplus-pagination__compact-jump{display:flex;align-items:center;gap:4px;color:#66728f;font-size:12px;white-space:nowrap}.cplus-pagination__compact-jump .el-input{width:38px}.cplus-pagination__compact-jump ::v-deep .el-input__inner{height:28px;padding:0 5px;text-align:center;line-height:26px;border-radius:7px}
.cplus-pagination ::v-deep .el-pagination{display:flex;min-height:34px!important;margin:0!important;padding:0!important;align-items:center;justify-content:flex-end;gap:8px;color:#5d6988;font-weight:500;white-space:nowrap;background:transparent!important;border:0!important;border-radius:0!important}
.cplus-pagination ::v-deep .el-pagination__total,.cplus-pagination ::v-deep .el-pagination__jump{height:34px;margin:0;line-height:34px}
.cplus-pagination ::v-deep .el-pagination .el-select .el-input{width:112px;margin-top:-3px}
.cplus-pagination ::v-deep .el-pagination .el-input__inner,.cplus-pagination ::v-deep .btn-prev,.cplus-pagination ::v-deep .btn-next,.cplus-pagination ::v-deep .el-pager li,.cplus-pagination__boundary,.cplus-pagination__refresh{min-width:34px;height:34px;padding:0 10px;line-height:32px;background:#fff;border:1px solid #dfe6f3;border-radius:8px;box-shadow:0 4px 12px rgba(88,101,154,.08)}
.cplus-pagination ::v-deep .el-pager li.active{color:#fff;background:linear-gradient(135deg,#20d6df 0%,#4f8cff 36%,#8158f5 70%,#ef5acb 100%);border:0;outline:0;box-shadow:0 6px 16px rgba(108,92,235,.24)}
.cplus-pagination ::v-deep .el-pagination.is-background .btn-prev:disabled,.cplus-pagination ::v-deep .el-pagination.is-background .btn-next:disabled,.cplus-pagination__boundary.is-disabled,.cplus-pagination__refresh.is-disabled{color:#bec7d8;background:#f7f9fc;box-shadow:none}
.cplus-pagination--compact{min-height:44px;padding:5px 8px;gap:6px}.cplus-pagination--compact .cplus-pagination__controls{width:100%;gap:4px}.cplus-pagination--compact ::v-deep .el-pagination{width:100%;gap:4px}.cplus-pagination--compact ::v-deep .el-pager{display:flex;min-width:0}.cplus-pagination--compact ::v-deep .btn-prev,.cplus-pagination--compact ::v-deep .btn-next,.cplus-pagination--compact ::v-deep .el-pager li{min-width:28px;height:28px;line-height:26px;border-radius:7px}
@media(max-width:1366px){.cplus-pagination{min-height:52px;padding:8px 10px;gap:8px}.cplus-pagination ::v-deep .el-pagination{gap:5px}.cplus-pagination ::v-deep .el-pagination .el-select .el-input{width:102px}}
</style>
